var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model-select',{attrs:{"options":_vm.options,"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }